import {
  IonBadge,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs
} from '@ionic/react';

import { Icon } from '@/components/memo';
import { useTabs } from '@/contexts';
import { Calendar, Profile, Requests } from '@/pages/dashboard';
import { ROUTES } from '@/utils/routes';
import { TABS } from '@/utils/tabs';
import {
  calendarClear,
  calendarClearOutline,
  fileTray,
  fileTrayOutline,
  person,
  personOutline
} from 'ionicons/icons';
import { Redirect, Route } from 'react-router-dom';

interface DashboardProps {
  pendingRequestsCount: number;
}

const Dashboard: React.FC<DashboardProps> = ({ pendingRequestsCount = 0 }) => {
  const { selectedTab, onTabButtonClick, onTabChange } = useTabs();

  return (
    <IonTabs onIonTabsDidChange={onTabChange}>
      <IonRouterOutlet animated={false}>
        {/* Dashboard Routes */}
        <Route exact path={ROUTES.ROOT}>
          <Calendar />
        </Route>
        <Route exact path={ROUTES.REQUESTS}>
          <Requests />
        </Route>
        <Route exact path={ROUTES.PROFILE}>
          <Profile />
        </Route>

        {/* Redirect non-dashboard routes to root */}
        <Route>
          <Redirect to={ROUTES.ROOT} />
        </Route>
      </IonRouterOutlet>
      <IonTabBar id="tab-bar" slot="bottom" mode="md">
        <IonTabButton
          tab={TABS.CALENDAR}
          href={ROUTES.CALENDAR}
          selected={selectedTab === TABS.CALENDAR}
          onClick={() => onTabButtonClick(TABS.CALENDAR)}
        >
          <Icon
            aria-hidden="true"
            icon={
              selectedTab === TABS.CALENDAR
                ? calendarClear
                : calendarClearOutline
            }
            color={selectedTab === TABS.CALENDAR ? 'primary' : 'default'}
          />
          <IonLabel>Calendar</IonLabel>
        </IonTabButton>
        <IonTabButton
          tab={TABS.REQUESTS}
          href={ROUTES.REQUESTS}
          selected={selectedTab === TABS.REQUESTS}
          onClick={() => onTabButtonClick(TABS.REQUESTS)}
        >
          <Icon
            aria-hidden="true"
            icon={selectedTab === TABS.REQUESTS ? fileTray : fileTrayOutline}
            color={selectedTab === TABS.REQUESTS ? 'primary' : 'default'}
          />
          {pendingRequestsCount > 0 && (
            <IonBadge color="danger">{pendingRequestsCount}</IonBadge>
          )}
          <IonLabel>Requests</IonLabel>
        </IonTabButton>
        <IonTabButton
          tab={TABS.PROFILE}
          href={ROUTES.PROFILE}
          selected={selectedTab === TABS.PROFILE}
          onClick={() => onTabButtonClick(TABS.PROFILE)}
        >
          <Icon
            aria-hidden="true"
            icon={selectedTab === TABS.PROFILE ? person : personOutline}
            color={selectedTab === TABS.PROFILE ? 'primary' : 'default'}
          />
          <IonLabel>Profile</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};

export default Dashboard;
